"use client";

import { FAQSection } from "@/components/sections/faq";
import { faq } from "@/lib/data/services-online-identity-management";

export function FAQ() {
  return (
    <FAQSection
      eyebrow={faq.eyebrow}
      title={faq.title}
      items={faq.items}
      accent={faq.accent}
    />
  );
}
